import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	tableData: null,
	primaryLinksData: null,
	secondaryLinksData: null,
	packageLinksData: null,
	descriptionText: null,
	simulationData: [],
	loading: [],
	inputParams: {},
	netlist: {},
	displayInput: {}
};

const modelDataSlice = createSlice({
	name: 'modelData',
	initialState,
	reducers: {
		setTableData: (state, action) => {
			state.tableData = action.payload;
		},
		setPrimaryLinksData: (state, action) => {
			state.primaryLinksData = action.payload;
		},
		setSecondaryLinksData: (state, action) => {
			state.secondaryLinksData = action.payload;
		},
		setPackageLinksData: (state, action) => {
			state.packageLinksData = action.payload;
		},
		setDescriptionText: (state, action) => {
			state.descriptionText = action.payload;
		},
		setInputParams: (state, action) => {
			const { simulationNumber, params } = action.payload;
			if (state.inputParams[simulationNumber]) {
				state.inputParams[simulationNumber] = params;
			} else {
				state.inputParams = {
					...state.inputParams,
					[simulationNumber]: params
				};
			}
		},
		setUpdateInputParams: (state, action) => {
			const { simulationNumber, mappingName, value } = action.payload;
			const inputParam = Object.values(state.inputParams[simulationNumber]).find(
				param => param.mappingName === mappingName
			);

			if (inputParam) {
				inputParam.value = value;
			}
		},
		setNetlist: (state, action) => {
			// action.payload should be an object { simulationNumber: number, netlist: netlist }
			const { simulationNumber, netlist } = action.payload;
			if (state.netlist[simulationNumber]) {
				state.netlist[simulationNumber] = netlist;
			} else {
				state.netlist = {
					...state.netlist,
					[simulationNumber]: netlist
				};
			}
		},
		setSimulationData: (state, action) => {
			if (state.simulationData === null) {
				state.simulationData = [action.payload];
			} else {
				let test = false;
				let simData = state.simulationData.map(data => {
					if (data.simulationId === action.payload.simulationId) {
						test = true;
						return action.payload;
					} else {
						return data;
					}
				});
				if (!test) {
					simData.push(action.payload);
				}
				state.simulationData = simData;
			}
		},
		setLoading: (state, action) => {
			if (Array.isArray(action.payload)) {
				state.loading = state.loading.filter(simNumber => simNumber !== action.payload[0]);
			} else {
				state.loading.push(action.payload);
			}
		},
		setDisplayInput: (state, action) => {
			const { mappingName, heading, simNumber, value, unit } = action.payload;
			const existingInput = state.displayInput[simNumber];

			state.displayInput[simNumber] = {
				mappingName,
				heading: heading === undefined ? existingInput?.heading : heading,
				value,
				unit
			};
		}
	}
});

export const {
	setTableData,
	setPrimaryLinksData,
	setSecondaryLinksData,
	setPackageLinksData,
	setDescriptionText,
	setSimulationData,
	setLoading,
	setInputParams,
	setUpdateInputParams,
	setNetlist,
	setDisplayInput
} = modelDataSlice.actions;

export default modelDataSlice.reducer;
